export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT ?? "";

// Admin Console is visible in EVERY environment, production included. It used
// to be gated to non-production, which left the prod tribunal with no console:
// login pushes a tribunal to /admin, and with the route unmounted that fell
// through to the catch-all NotFound (a bare spinner that calls history.goBack).
// Anything that reads this flag must keep working if it is ever flipped back
// off — see the tribunal landing fallback in AppkitComponent.
export const ADMIN_CONSOLE_ENABLED = true;

// Collateral + Circulating Supply tabs (plan 13). Separate from
// ADMIN_CONSOLE_ENABLED so they can be pulled without taking the whole console
// down: they are the only tabs backed by on-chain sweeps, so if an RPC problem
// makes them misleading they should be removable in one flip, with no backend
// rollback. One flag covers both because they share that risk exactly. The two
// endpoints behind them are additive and read-only — nothing else calls them,
// so leaving them deployed while the tabs are hidden is inert.
export const ADMIN_CHAIN_REPORT_TABS_ENABLED = true;
